export * from './module';

export * from './shared';
export * from './share-map';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/share-map/index.ts